<template>
  <AuthWrapper :title="title">
    <AuthForm/>
  </AuthWrapper>
</template>

<script>
import AuthForm from 'common/components/auth/AuthForm';
import AuthWrapper from 'common/components/auth/AuthWrapper';

export default {
  name: 'AuthPage',
  components: {
    AuthForm,
    AuthWrapper,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
